import { gql } from '@apollo/client'

export const csvTransactionsGql = gql`
    query csvTransactions(
        $lpn: String,
        $amount: Float,
        $beginEnd: [String],
        $targetTZ: String,
        $state: String
    ) {
        csvTransactions(
            lpn: $lpn,
            amount: $amount,
            beginEnd: $beginEnd,
            targetTZ: $targetTZ,
            state: $state
        ) {
            downloadURL
        }
    }
`